import { render, staticRenderFns } from "./gesamtauswertung_page.vue?vue&type=template&id=5af818c9&scoped=true"
import script from "./gesamtauswertung_page.vue?vue&type=script&lang=js"
export * from "./gesamtauswertung_page.vue?vue&type=script&lang=js"
import style0 from "./gesamtauswertung_page.vue?vue&type=style&index=0&id=5af818c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af818c9",
  null
  
)

export default component.exports